import { getLocalizedPath } from "@/lib/i18nRoutes";

export const SUPPORTED_LANGS = ["en", "he", "es", "it", "fr", "de", "pt", "ar", "el", "ru", "tr", "zh"];

export class LearningUrlError extends Error {
  constructor(message) {
    super(message);
    this.name = "LearningUrlError";
  }
}

export function normalizeLearningLang(lang) {
  return SUPPORTED_LANGS.includes(lang) ? lang : "en";
}

function requireSegment(value, name) {
  if (!value || String(value).trim() === "") {
    throw new LearningUrlError(`Missing learning URL ${name}`);
  }
  return encodeURIComponent(String(value).trim());
}

export function languageHomeUrl(lang) {
  return `/${normalizeLearningLang(lang)}/`;
}

export function learningCenterUrl(lang) {
  const safeLang = normalizeLearningLang(lang);
  const localizedPath = getLocalizedPath("learningCenter", safeLang);
  return localizedPath !== "/404" ? localizedPath : `/${safeLang}/learning-center`;
}

export function learningCategoryUrl({ lang, category }) {
  return `${learningCenterUrl(lang)}/${requireSegment(category, "category")}`;
}

export function learningArticleUrl({ lang, category, slug }) {
  return `${learningCenterUrl(lang)}/${requireSegment(category, "category")}/${requireSegment(slug, "slug")}`;
}

export function getArticleLocalizedSlug(article, lang = "en") {
  if (!article) return "";
  return article.translations?.[lang]?.slug || article.localized_slugs?.[lang] || article.slug || "";
}

export function localizedLearningArticleUrl({ lang, category, article }) {
  return learningArticleUrl({
    lang,
    category: category || article?.main_category,
    slug: getArticleLocalizedSlug(article, lang),
  });
}

export function articleMatchesLearningSlug(article, slug, lang = "en") {
  const normalized = decodeURIComponent(String(slug || "")).trim();
  if (!article || !normalized) return false;
  const slugs = new Set([
    article.slug,
    article.localized_slugs?.[lang],
    article.translations?.[lang]?.slug,
    ...Object.values(article.localized_slugs || {}),
    ...Object.values(article.translations || {}).map((translation) => translation?.slug),
  ].filter(Boolean).map((value) => String(value).trim()));
  return slugs.has(normalized);
}